// extracted by mini-css-extract-plugin
module.exports = {"input":"PasswordResetMailForm_input__w_F6T","inputError":"PasswordResetMailForm_inputError__8afOm"};